import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Layout.css';

const Header: React.FC = () => {
  const navigate = useNavigate();

  return (
    <header className="app-header" role="banner">
      <div className="header-content">
        <div className="header-left">
          <h1 className="app-logo" onClick={() => navigate('/')}>
            Geography Game
          </h1>
        </div>

        <nav className="header-nav" role="navigation" aria-label="Main navigation">
          <button
            className="nav-link"
            onClick={() => navigate('/')}
            aria-label="Go to home"
          >
            Play
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
